import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'header';
const slidableBreakpoint = '767px';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class header {
  constructor(el) {
    this.el = el;

    $(el).css('--headerheight', '-' + $(el).height() + 'px');

    this.mediaMatcher = window.matchMedia(`(min-width: ${slidableBreakpoint})`);

    if (this.mediaMatcher.matches) {
      $(el).find(`.${baseClass}`).removeClass('has-shadow');
    }

    this.mediaMatcher.addEventListener('change', (event) => {
      if (event.matches) {
        $(el).find(`.${baseClass}`).removeClass('has-shadow');
      }
    });

    function headerScroll(element) {
      if ($(window).width() > 768) {
        const scrollPos = element.scrollTop();
        const headerHeight = $(el).height();

        if (scrollPos > headerHeight) {
          $(el).addClass('is-scroll');
          $(el).addClass('sticky-top');
        } else {
          $(el).removeClass('is-scroll');
          $(el).removeClass('sticky-top');
        }
      }
    }

    if ($(window).width() > 768) {
      if (window.scrollY > 0) {
        $(el).addClass('is-scroll');
        $(el).addClass('sticky-top');
      }
    }

    $(document).scroll(function () {
      headerScroll($(this));
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new header(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
